import {
  Timestamp,
  collection,
  getCountFromServer,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  where,
} from "@firebase/firestore";
import { getStudentsPartial } from "./students_partial";

const firestore = getFirestore();

export async function getAttendaceCount() {
  const attendaceRef = collection(firestore, "attendance_history");
  const timeStart = new Date();
  timeStart.setHours(0, 0, 0, 0);
  const attendaceQuery = query(attendaceRef, where("time", ">", timeStart));
  const attendance = (await getCountFromServer(attendaceQuery)).data().count;
  return attendance;
}

export async function getInOutCount() {
  const studentRef = collection(firestore, "students_partial");
  const inQuery = query(studentRef, where("isIn", "==", true));
  const outQuery = query(studentRef, where("isIn", "!=", true));
  const totalIn = (await getCountFromServer(inQuery)).data().count;
  const totalOut = (await getCountFromServer(outQuery)).data().count;
  return { totalIn: totalIn, totalOut: totalOut };
}

export async function getInOutHistory(count) {
  const inOutHistoryQuery = query(
    collection(firestore, "inout_history"),
    orderBy("time", "desc"),
    limit(count)
  );
  const inOutHistoryEntries = await getDocs(inOutHistoryQuery);
  if (inOutHistoryEntries.empty) {
    throw new Error(`No in-out history found.`);
  }
  let inOutHistory = [];
  const studentDataPromises = [];
  inOutHistoryEntries.forEach((inOutEntry) => {
    if (inOutEntry.exists()) {
      const inOutEntryData = inOutEntry.data();
      studentDataPromises.push(getStudentsPartial(inOutEntryData.admissionNo));
      inOutHistory.push({ ...inOutEntryData, id: inOutEntry.id });
    }
  });
  const studentData = await Promise.all(studentDataPromises);
  inOutHistory = inOutHistory.map((inout, index) => {
    return { ...studentData[index], ...inout };
  });
  return inOutHistory;
}
